<template>
	<base-row>
		<form>
			<base-form-section v-for="(section, sectionIdx) in schema.sections" :heading="section.heading" :key="sectionIdx">
				<base-row v-for="(row, rowIdx) in section.rows" :key="rowIdx">
					<base-column v-for="(element, name) in row" :sizes="element.sizes" :key="name">
						<renderer
							:element="element"
							:key="name"
							:name="name"
							:error="errors && errors[name] ? errors[name] : null"
							v-model="form[name]"
							@input="handleFormInput"

						/>
					</base-column>
				</base-row>
			</base-form-section>
		</form>
		<pre v-if="debug===true">{{ form }}</pre>
	</base-row>

</template>
<script>
import BaseFormSection from "./BaseFormSection.vue";
import BaseRow from "../ui/layout/BaseRow.vue";
import Renderer from "./Renderer.vue";
import BaseColumn from "../ui/layout/BaseColumn.vue";

export default {
	components: {BaseColumn, Renderer, BaseRow, BaseFormSection},
	props: {
		schema: {
			type: Object,
			required: true
		},
		errors: {
			type: Object,
			required: true
		},
		value: {
			type: Object,
			required: false
		},
		debug: {
			type: Boolean,
			default: false,
			required: false
		}
	},
	data() {
		return {
			form: {}
		}
	},
	mounted() {
		this.form = {...this.form, ...this.value}
	},

	methods: {
		handleFormInput(value) {
			this.$emit('input', this.form)
		}
	}
}
</script>